export default "__VITE_ASSET__DPpfOv11__"